import { Link } from 'react-router-dom';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';
import Contact from '../../home/components/Contact';
import WhatsAppDiagnostic from '../../home/components/WhatsAppDiagnostic';

export default function RenovationFenetresAnciennesLyon() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-amber-700 via-orange-600 to-amber-600 pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl">
            <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              <i className="ri-ancient-gate-line text-white"></i>
              <span className="text-white text-sm font-medium">Patrimoine Lyonnais</span>
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-extrabold text-white mb-6 leading-tight">
              Rénovation Fenêtres Anciennes Lyon
            </h1>
            
            <p className="text-xl text-white/90 mb-8 leading-relaxed">
              Guide complet pour rénover vos fenêtres anciennes à Lyon. Conservation du patrimoine, techniques de restauration et amélioration des performances énergétiques.
            </p>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <article className="prose prose-lg max-w-none">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              Rénovation de Fenêtres Anciennes à Lyon : Guide Complet
            </h2>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Lyon possède un patrimoine architectural exceptionnel avec de nombreux immeubles anciens dotés de fenêtres d'époque. La rénovation de ces fenêtres anciennes nécessite un savoir-faire spécifique pour préserver leur charme tout en améliorant leurs performances. Ce guide vous accompagne dans votre projet de rénovation.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Pourquoi Rénover plutôt que Remplacer ?
            </h3>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Conservation du patrimoine :</strong> Préservation de l'authenticité architecturale lyonnaise</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Contraintes réglementaires :</strong> Obligation dans les secteurs sauvegardés (Vieux-Lyon, Presqu'île)</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Économie :</strong> Souvent moins coûteux qu'un remplacement complet</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Qualité des matériaux :</strong> Bois ancien souvent de meilleure qualité</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Écologie :</strong> Réduction des déchets et de l'empreinte carbone</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Diagnostic de l'État des Fenêtres
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Avant toute rénovation, un diagnostic précis est essentiel :
            </p>

            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-search-line text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>État du bois :</strong> Vérifiez la présence de pourriture, d'insectes xylophages ou de champignons</span>
              </li>
              <li className="flex items-start">
                <i className="ri-search-line text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Solidité du cadre :</strong> Testez la stabilité et l'absence de déformation</span>
              </li>
              <li className="flex items-start">
                <i className="ri-search-line text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>État du vitrage :</strong> Simple vitrage à remplacer par du double vitrage</span>
              </li>
              <li className="flex items-start">
                <i className="ri-search-line text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Quincaillerie :</strong> Fonctionnement des poignées, crémones et charnières</span>
              </li>
              <li className="flex items-start">
                <i className="ri-search-line text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Étanchéité :</strong> Présence de courants d'air ou d'infiltrations</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Étapes de la Rénovation
            </h3>
            
            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              1. Traitement du Bois
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Le traitement du bois est la première étape cruciale. À Lyon, l'humidité peut avoir endommagé le bois ancien. Décapage complet de l'ancienne peinture, traitement anti-humidité et anti-insectes, remplacement des parties trop abîmées par du bois de même essence, et consolidation des assemblages.
            </p>

            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              2. Amélioration de l'Isolation
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              L'isolation est le point faible des fenêtres anciennes. Solutions possibles : remplacement du simple vitrage par du double vitrage fin (adapté aux feuillures anciennes), pose de joints d'étanchéité modernes, ajout de coupe-froid sur les ouvrants, et amélioration de l'étanchéité à l'air.
            </p>

            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              3. Rénovation de la Quincaillerie
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              La quincaillerie ancienne peut souvent être restaurée. Nettoyage et restauration des ferrures d'origine, remplacement des pièces défectueuses par des modèles compatibles, installation de systèmes de fermeture modernes discrets, et ajout de sécurité anti-effraction si nécessaire.
            </p>

            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              4. Finitions Esthétiques
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Les finitions redonnent tout leur éclat aux fenêtres. Ponçage minutieux du bois, application de lasure ou peinture adaptée au patrimoine, respect des couleurs d'origine ou du cahier des charges des Bâtiments de France, et protection UV pour prolonger la durée de vie.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Contraintes Spécifiques à Lyon
            </h3>
            
            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Secteurs Sauvegardés
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Dans le Vieux-Lyon et certains quartiers de la Presqu'île, toute modification de fenêtre nécessite l'accord de l'Architecte des Bâtiments de France (ABF). Respect strict des dimensions et proportions d'origine, conservation des matériaux traditionnels (bois obligatoire), couleurs imposées selon le secteur, et interdiction du PVC dans la plupart des cas.
            </p>

            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Immeubles Classés ou Inscrits
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Pour les immeubles classés Monuments Historiques, les contraintes sont encore plus strictes. Autorisation préalable obligatoire, intervention d'artisans spécialisés en restauration du patrimoine, utilisation de techniques et matériaux traditionnels, et subventions possibles de la DRAC.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Techniques de Restauration Traditionnelles
            </h3>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-hammer-line text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Greffage du bois :</strong> Remplacement partiel des parties abîmées</span>
              </li>
              <li className="flex items-start">
                <i className="ri-hammer-line text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Assemblages traditionnels :</strong> Tenons-mortaises, queues d'aronde</span>
              </li>
              <li className="flex items-start">
                <i className="ri-hammer-line text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Peinture à l'ancienne :</strong> Peinture à l'huile ou à la caséine</span>
              </li>
              <li className="flex items-start">
                <i className="ri-hammer-line text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Mastic traditionnel :</strong> Pour la pose du vitrage</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Coût de la Rénovation à Lyon
            </h3>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-money-euro-circle-line text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Rénovation simple :</strong> 300€ à 600€ par fenêtre (traitement, peinture, joints)</span>
              </li>
              <li className="flex items-start">
                <i className="ri-money-euro-circle-line text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Rénovation complète :</strong> 600€ à 1200€ (+ double vitrage, quincaillerie)</span>
              </li>
              <li className="flex items-start">
                <i className="ri-money-euro-circle-line text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Restauration patrimoine :</strong> 1000€ à 2000€ (techniques traditionnelles)</span>
              </li>
              <li className="flex items-start">
                <i className="ri-money-euro-circle-line text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Double vitrage sur mesure :</strong> 200€ à 400€ supplémentaires</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Aides Financières Disponibles
            </h3>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-gift-line text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>MaPrimeRénov' :</strong> Jusqu'à 100€ par fenêtre pour amélioration énergétique</span>
              </li>
              <li className="flex items-start">
                <i className="ri-gift-line text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Subventions DRAC :</strong> Pour immeubles classés (jusqu'à 40% des travaux)</span>
              </li>
              <li className="flex items-start">
                <i className="ri-gift-line text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Fondation du Patrimoine :</strong> Aide pour immeubles remarquables</span>
              </li>
              <li className="flex items-start">
                <i className="ri-gift-line text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>TVA réduite :</strong> 5.5% pour rénovation énergétique</span>
              </li>
              <li className="flex items-start">
                <i className="ri-gift-line text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Aides locales :</strong> Métropole de Lyon et Ville de Lyon selon secteurs</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Choisir le Bon Artisan
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              La rénovation de fenêtres anciennes nécessite un savoir-faire spécifique :
            </p>

            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-star-line text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Qualification RGE :</strong> Pour bénéficier des aides financières</span>
              </li>
              <li className="flex items-start">
                <i className="ri-star-line text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Expérience patrimoine :</strong> Références sur immeubles anciens lyonnais</span>
              </li>
              <li className="flex items-start">
                <i className="ri-star-line text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Label Qualibat :</strong> Gage de qualité et de sérieux</span>
              </li>
              <li className="flex items-start">
                <i className="ri-star-line text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Connaissance réglementaire :</strong> Maîtrise des contraintes ABF</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Entretien après Rénovation
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Une fois rénovées, vos fenêtres anciennes nécessitent un entretien régulier :
            </p>

            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-calendar-check-line text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Peinture/lasure :</strong> Tous les 5 à 8 ans selon exposition</span>
              </li>
              <li className="flex items-start">
                <i className="ri-calendar-check-line text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Traitement du bois :</strong> Tous les 10 ans en préventif</span>
              </li>
              <li className="flex items-start">
                <i className="ri-calendar-check-line text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Vérification joints :</strong> Annuelle, remplacement si nécessaire</span>
              </li>
              <li className="flex items-start">
                <i className="ri-calendar-check-line text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Lubrification :</strong> Mécanismes 1 fois par an</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Conclusion
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              La rénovation de fenêtres anciennes à Lyon est un projet qui allie respect du patrimoine et amélioration des performances énergétiques. Avec un artisan qualifié et les bonnes techniques, vos fenêtres d'époque peuvent retrouver leur splendeur tout en offrant un confort moderne. N'hésitez pas à vous renseigner sur les aides disponibles et les contraintes réglementaires avant de démarrer votre projet.
            </p>
          </article>
        </div>
      </section>

      {/* WhatsApp Diagnostic */}
      <WhatsAppDiagnostic />

      {/* Contact */}
      <Contact />
      
      <Footer />
    </div>
  );
}
